import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tw-my-[30px]" }
const _hoisted_2 = {
  key: 0,
  class: "boxes"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "tw-absolute tw-top-[-12px] tw-right-[-19px]"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultMark = _resolveComponent("ResultMark")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.step == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syllables?.correct, (s, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: s.id,
                class: _normalizeClass(["tw-inline-block tw-px-[5px]", 'act-dl-cl-' + (key + 1)])
              }, _toDisplayString(s.value), 3))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.step > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syllables?.correct, (s, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: s.id,
                class: "tw-relative tw-top-0 tw-left-0 tw-inline-block tw-m-[10px]"
              }, [
                (_ctx.canGoToSyllable(key))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "",
                      class: _normalizeClass(["tw-block tw-p-[10px] tw-border tw-border-solid act-dl-border hover:tw-bg-primaryvlt tw-no-underline", 'act-dl-cl-' + (key + 1)]),
                      onClick: _withModifiers(($event: any) => (_ctx.selectSyllable(key)), ["prevent"])
                    }, _toDisplayString(_ctx.getSyllableValue(key)), 11, _hoisted_4))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["tw-block tw-p-[10px] tw-border tw-border-solid act-dl-border", 'act-dl-cl-' + (key + 1)])
                    }, _toDisplayString(_ctx.getSyllableValue(key)), 3)),
                (_ctx.optionResults.length > key)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_ResultMark, {
                        result: _ctx.optionResults[key] > 0
                      }, null, 8, ["result"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syllables?.options[_ctx.currentSyllable], (s) => {
              return (_openBlock(), _createElementBlock("div", {
                key: s.id,
                class: "tw-inline-block tw-m-[10px]"
              }, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _withModifiers(($event: any) => (_ctx.selectOption(s.value)), ["prevent"]),
                  class: _normalizeClass(["tw-block tw-p-[10px] tw-border tw-border-solid act-dl-border hover:tw-bg-primaryvlt tw-no-underline", 'act-dl-cl-' + (_ctx.currentSyllable + 1)])
                }, _toDisplayString(s.value), 11, _hoisted_7)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.step == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "sf-btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.begin && _ctx.begin(...args)))
          }, "Begin")
        ]))
      : _createCommentVNode("", true),
    (_ctx.step == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "sf-btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.check && _ctx.check(...args)))
          }, "Check")
        ]))
      : _createCommentVNode("", true)
  ]))
}